<nvps-side-nav></nvps-side-nav>
<div class="outlet-wrapper"><router-outlet></router-outlet></div>
